export default "__VITE_ASSET__CE4nSrBo__"